import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const BlogSection = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage, setBlogsPerPage] = useState(12);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm")); // sm = 600px+
  const placeholderText = "Search blog..."; // Text to animate
  const [displayText, setDisplayText] = useState("");
  const [index, setIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const typingSpeed = 250; // ms per character

    const interval = setInterval(() => {
      setDisplayText(placeholderText.slice(0, index + 1));
      setIndex((prev) => {
        if (prev + 1 === placeholderText.length) {
          return 0; // restart after reaching full length
        }
        return prev + 1;
      });
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [index]);

  const blogs = [
    {
      id: "1",
      title: "7-benefits-digital-signage",
      heading:
        "7 Top Benefits of Digital Signage Displays for Retail Campaigns in 2025",
      description:
        "Discover 7 key benefits of digital signage displays for retail in 2025: increased engagement, real-time updates, personalization, etc.",
      author: "Rubina",
      date: "May 13, 2025",
      image: "/assests/images/LandingPage/blogs/blog1/blog-title-img.webp",
    },
    {
      id: "2",
      title: "best-signage-retail-execution",
      heading:
        "5 Things to Consider for Choosing the Best Signage Campaign Execution Partner in India",
      description:
        "Discover 5 crucial factors for selecting the best signage retail execution partner in India with the Pixell.",
      author: "Rubina",
      date: "May 14, 2025",
      image: "/assests/images/LandingPage/blogs/blog2/blog-title-img.webp",
    },
    {
      id: "3",
      title: "retail-signage-manufacturing",
      heading:
        "How Retail Signage Manufacturing Companies Drive ROI for Brands",
      description:
        "Discover how retail signage manufacturing drives measurable ROI through digital transformation, hyperlocal execution, and quality control. ",
      author: "Rubina",
      date: "May 15, 2025",
      image: "/assests/images/LandingPage/blogs/blog3/blog-title-img.webp",
    },
    {
      id: "4",
      title: "overcoming-transparency-issues-in-signage",
      heading:
        "How to Overcome Transparency Issues in Signage Production in 2025",
      description:
        "Discover effective transparent signage solutions to overcome transparency issues in signage production for 2025. ",
      author: "Rubina",
      date: "May 20, 2025",
      image: "/assests/images/LandingPage/blogs/blog4/blog-title-img.webp",
    },
    {
      id: "5",
      title: "10-Retail-Signage-Trends-for-2025",
      heading: "10 Must-Know Retail Signage Trends for 2025.",
      description:
        "Discover 2025's top retail signage trends including interactive displays, sustainable materials, AR integration and many more.",
      author: "Rubina",
      date: "May 22, 2025",
      image: "/assests/images/LandingPage/blogs/blog5/blog-title-img.webp",
    },
    {
      id: "6",
      title: "5-Multi-Location-Signage-Rollout-Challenges-and-Their-Solutions",
      heading:
        "5 Multi-Location Signage Rollout Challenges and Their Solutions",
      description:
        " Address the most common 5 Multi-Location Signage Rollout challenges  faced by brands and how to tackle them efficiently.",
      author: "Rubina",
      date: "May 28, 2025",
      image: "/assests/images/LandingPage/blogs/blog6/blog-title-img.webp",
    },
    // {
    //   id: "7",
    //   title: "7-Steps-to-Ensure-Compliance-with-2025-Signage-Regulations",
    //   heading: "7 Steps to Ensure Compliance with 2025 Signage Regulations",
    //   description:
    //     "Ensure your retail signage meets 2025 signage regulations with this step-by-step compliance guide and execute your retail campaign smoothly.",
    //   author: "Rubina",
    //   date: "June 3, 2025",
    //   image: "/assests/images/LandingPage/blogs/blog7/blog-title-img.webp",
    // },
    {
      id: "7",
      title: "How-LED-Display-Technology-Is-Transforming-Digital-Signage",
      heading: "How LED Display Technology Is Transforming Digital Signage",
      description:
        "Discover how LED Display technology transforms digital signage for retail stores through smart signage solutions.",
      author: "Rubina",
      date: "June 10, 2025",
      image: "/assests/images/LandingPage/blogs/blog8/blog-title-img.webp",
    },
    {
      id: "8",
      title:
        "How-to-Enhance-Customer-Engagement-with-Interactive-Signage-in-2025",
      heading:
        "How to Enhance Customer Engagement with Interactive Signage in 2025",
      description:
        "Explore key trends for 2025, from AI personalisation to AR, and learn how to implement these strategies for retail success.",
      author: "Rubina",
      date: "Sept 2, 2025",
      image: "/assests/images/LandingPage/blogs/blog9/Picture1.webp",
    },
    {
      id: "9",
      title: "6-Essential-Project-Management-Tips-to-Navigate-Custom-Signage",
      heading: "6 Essential Project Management Tips to Navigate Custom Signage",
      description:
        "Discover six essential tips for effective project management, from planning to installation, and ensure your project's success.",
      author: "Rubina",
      date: "Sept 4, 2025",
      image: "/assests/images/LandingPage/blogs/blog10/Picture1.webp",
    },
  ];

  //   // Set number of blogs per page based on screen size
  //   useEffect(() => {
  //     const handleResize = () => {
  //       if (window.innerWidth < 640) {
  //         setBlogsPerPage(1);
  //       } else if (window.innerWidth < 1024) {
  //         setBlogsPerPage(2);
  //       } else {
  //         setBlogsPerPage(3);
  //       }
  //     };
  //     handleResize(); // Set initially
  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  //   }, []);

  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const filteredBlogs = sortedBlogs.filter((blog) =>
    blog.heading.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);
  const startIdx = (currentPage - 1) * blogsPerPage;
  const currentBlogs = filteredBlogs.slice(startIdx, startIdx + blogsPerPage);

  return (
    <div className=" py-8">
      <div className=" mb-8 md:mb-12 flex justify-between items-center">
        <div className=" w-full">
          <div className="flex justify-between items-center mb-2">
            <h5 className="text-sm uppercase text-gray-500 ">Our Blog</h5>
            <div className=" flex w-48 items-center justify-center">
              <TextField
                fullWidth
                variant="outlined"
                placeholder={displayText}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  width: { xs: "90%", sm: "200px", md: "500px" },
                  backgroundColor: "white",
                  borderRadius: "9999px", // fully rounded
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "9999px",
                    height: { sm: "24px", md: "38px" }, // 🔥 controls overall height
                    fontSize: "0.875rem", // smaller text
                    paddingRight: "8px",
                    "&:hover fieldset": {
                      borderColor: "#60A5FA", // Tailwind light-blue-400
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3B82F6", // Tailwind blue-500
                      borderWidth: "2px",
                    },
                  },
                  "& .MuiInputBase-input": {
                    padding: "8px 14px", // adjust text padding inside
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton color="primary">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>

          <h2 className="text-xl md:text-4xl font-bold">
            Discover Our Latest Articles
          </h2>
        </div>
      </div>

      <div className=" mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {currentBlogs.length > 0 ? (
          currentBlogs.map((blog, idx) => (
            <div
              key={idx}
              className="bg-[#1e293b] transition-colors duration-300 rounded-xl shadow-md p-4 max-w-sm h-[460px] flex flex-col justify-between overflow-hidden"
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="rounded-md mb-4 w-full h-[200px] object-contain"
              />
              <h2 className="text-white text-lg font-bold mb-2">
                {blog.heading}
              </h2>
              <p className="text-slate-300 text-sm mb-4 line-clamp-3">
                {blog.description}
              </p>
              <div className="flex justify-between items-center gap-2 mt-auto">
                <div>
                  <p className="text-white text-sm">{blog.author}</p>
                  <p className="text-slate-400 text-xs">{blog.date}</p>
                </div>
                {/* <button
                type="button"
                onClick={() => navigate(`/blogs/${blog.title}`)}
                className="text-white bg-[#1e293b] hover:bg-white hover:text-[#1e293b] border-2 border-white-500 cursor-pointer font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
              >
                Read More
                <svg
                  className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 5h12m0 0L9 1m4 4L9 9"
                  />
                </svg>
              </button> */}
                <Link
                  to={`/blogs/${encodeURIComponent(blog.title)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white bg-[#1e293b] hover:bg-white hover:text-[#1e293b] border-2 border-white cursor-pointer font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                  aria-label={`Read more about ${blog.title}`}
                >
                  Read More
                  <svg
                    className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p className="text-black col-span-3 text-center">No blogs found.</p>
        )}
      </div>

      {totalPages > 1 && (
        <div className="mt-10 mx-2 flex justify-center pb-10">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              color="primary"
              shape="rounded"
              size={isLargeScreen ? "medium" : "small"}
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

export default BlogSection;
